declare var Swal;

namespace AgerLMS.Common {

}
